import { request } from 'sonata-react-components';

export async function getWalletAmount(
  userId: string,
  token: Record<string, any>
): Promise<{ amount: number; currency: string }> {
  return request.makeRequest(`${taptap.config.sonataBackendUrl}user/budget/${userId}`, token);
}
